export const cookieNames = {
  token: 'LANDLORDACCESSSESSION',
  role: 'USERROLE',
  level: 'ACCOUNTLEVEL',
  landlordName: 'LANDLORDNAME',
  landlordSlug: 'LANDLORDSLUG',
  landlordContact: 'LANDLORDCONTACT',
  agentToken: 'AGENTACCESSSESSION',
  partnerId: 'PARTNERID',
  partner: 'PARTNER',
  username: 'USERNAME',
  systemName: 'SYSTEMNAME',
};

export const storageNames = {
  paymentsetupProperties: 'PAYMENTSETUPPROPERTIES',
};
